@if (!inputService.hidden && inputService.formInputDefinition && inputService.control) {
  <ng-container [formGroup]="inputService.formGroup">
    <label>{{inputService.computedTitle | translate}}</label>
    <br>
      <mat-radio-group [formControlName]='inputService.formControlKey' class='mb-8'>
        @for (selectOption of selectOptions; track selectOption) {
          <mat-radio-button [value]="selectOption.value">
            <span>{{selectOption.label}}</span>
          </mat-radio-button>
        }
      </mat-radio-group>
    </ng-container>
  }